// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8ac74029","239":"adce44f4","455":"765c583d"}[chunkId] + ".chunk.js";
};